import * as React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import { getResourceUrl } from '../../helpers/urls';

const ResourceLink = ({
  resource,
  className,
  children,
  alternateLanguage,
  ...props
}) => {
  if (!resource) return null;

  const { __typename, node_locale, language } = resource;
  const url = getResourceUrl(resource);

  const LinkComponent =
    __typename === 'ContentfulPageSuccessStory' ? 'a' : Link;

  const urlProp =
    LinkComponent === 'a'
      ? { href: url, hreflang: alternateLanguage ?? language ?? node_locale }
      : { to: url, language: alternateLanguage ?? language ?? node_locale };

  return (
    <LinkComponent className={className} {...props} {...urlProp}>
      {children}
    </LinkComponent>
  );
};

export default ResourceLink;
